<mat-card [attr.data-testid]="'action-card'">
  <mat-card-header>
    <mat-card-title i18n [attr.data-testid]="'action-title'"
      >動作</mat-card-title
    >
  </mat-card-header>

  <mat-divider> </mat-divider>

  <mat-card-content [formGroup]="formGroup">
    <div class="label">
      <div class="title" [attr.data-testid]="'action-type-label'">
        {{ 'type' | cht }}
      </div>
      <programmable
        [title]="'type' | cht"
        [value]="formGroup.value['type']"
        (valueChange)="formGroup.controls['type'].setValue($event); doChange()"
      >
        <mat-form-field legacyAppearance>
          <mat-select
            [attr.data-testid]="'action-type-select'"
            formControlName="type"
            (selectionChange)="changeActionType($event.value); doChange()"
          >
            @for (option of options.Action; track option) {
              @if (option.enable) {
                <mat-option
                  [value]="option.value"
                  [attr.data-testid]="'action-type-option-' + option.value"
                  [disabled]="
                    isActionDisabled(option.value, formGroup.value['type'])
                  "
                >
                  {{ option.text || option.value }}
                </mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
      </programmable>
    </div>

    @for (property of actionProperties[formGroup.value.type]; track property) {
      <div
        class="label"
        [attr.data-testid]="'action-property-' + property.name"
      >
        <div
          class="title"
          [attr.data-testid]="'action-property-label-' + property.name"
        >
          {{ property.name | cht }}
          @if (
            (formGroup.value.type === 'share-message' ||
              formGroup.value.type === 'share-add-friend') &&
            property.name === 'messageId'
          ) {
            <mat-icon
              [matTooltip]="option_tooltip"
              class="!text-[20px] !w-[20px] !h-[20px]"
              >help</mat-icon
            >
            <ng-template #option_tooltip>
              <ms-share-message-hint
                [type]="formGroup.value.type"
              ></ms-share-message-hint>
            </ng-template>
          }
        </div>
        @if (property.options) {
          <programmable
            [title]="property.name | cht"
            [value]="formGroup.value[property.name]"
            (valueChange)="
              formGroup.controls[property.name].setValue($event); doChange()
            "
          >
            <mat-form-field legacyAppearance>
              <mat-select
                [attr.data-testid]="'action-property-select-' + property.name"
                [formControlName]="property.name"
                (selectionChange)="
                  property.name === 'scheme' ? false : resetTimes();
                  property.name === 'scheme'
                    ? changeUrlType($event.value)
                    : doChange()
                "
              >
                @if (property.options) {
                  @for (option of property.options; track option) {
                    <mat-option
                      [value]="option.value"
                      [attr.data-testid]="
                        'action-property-option-' +
                        property.name +
                        '-' +
                        option.value
                      "
                    >
                      {{ option.text || option.value }}
                    </mat-option>
                  }
                }
                @if (property.asyncOptions) {
                  @for (option of property.asyncOptions | async; track option) {
                    <mat-option
                      [value]="option.value"
                      [attr.data-testid]="
                        'action-property-async-option-' +
                        property.name +
                        '-' +
                        option.value
                      "
                    >
                      {{ option.text || option.value }}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          </programmable>
        }
        @if (property.hint) {
          <programmable
            [title]="property.name | cht"
            [value]="formGroup.value[property.name]"
            (valueChange)="
              formGroup.controls[property.name].setValue($event); doChange()
            "
          >
            <gosu-datetime-picker
              [attr.data-testid]="'action-datetime-picker-' + property.name"
              [value]="formGroup.value[property.name]"
              [inputFormat]="hint"
              [hint]="property.error || hint"
              [type]="formGroup.value.mode"
              [error]="!!property.error"
              (valueChange)="
                formGroup.controls[property.name].setValue($event); doChange()
              "
            >
            </gosu-datetime-picker>
          </programmable>
        }
        @if (property.treeOptions) {
          <programmable
            [title]="property.name | cht"
            [value]="formGroup.value[property.name]"
            (valueChange)="
              formGroup.controls[property.name].setValue($event); doChange()
            "
          >
            <mat-form-field
              floatLabel="always"
              class="select"
              legacyAppearance
              *asyncJob="property.treeOptions; let options"
            >
              <input
                matInput
                [matTreePicker]="treePicker"
                readonly
                class="cursor-pointer"
                [value]="property.sharePackageName ?? ''"
              />
              <button mat-icon-button matSuffix class="!w-6 !h-6">
                <mat-icon class="!w-5 !h-5">arrow_drop_down</mat-icon>
              </button>
              <mat-tree-picker
                #treePicker
                side="right"
                [dataSource]="filterDataSource(options)"
              >
                <mat-tree-picker-node
                  *matTreePickerNodeDef="let item"
                  (selected)="selectMessage(property, $event, treePicker)"
                  [attr.disabled]="getDisabledAttribute(item)"
                >
                  @if (
                    item.type === 'create-folder' ||
                    item.type === 'create-message'
                  ) {
                    <div class="text-center px-5 flex items-center gap-1">
                      <mat-icon class="!leading-none">add</mat-icon>
                      <span i18n>{{ item.name }}</span>
                    </div>
                  } @else {
                    {{ item.name }}
                  }
                </mat-tree-picker-node>
              </mat-tree-picker>
            </mat-form-field>
            @if (property.messageId) {
              <button mat-icon-button matSuffix (click)="editMessage(property)">
                <mat-icon>edit</mat-icon>
              </button>
            } @else {
              <button
                mat-icon-button
                matSuffix
                matTooltip="建立分享訊息"
                i18n-matTooltip="建立分享訊息"
                (click)="createMessage(property)"
              >
                <mat-icon>add</mat-icon>
              </button>
            }
          </programmable>
        }
        @if (
          !property.hint &&
          !property.options &&
          !property.treeOptions &&
          property.name !== 'altUri'
        ) {
          <programmable
            [title]="property.name | cht"
            [value]="formGroup.value[property.name]"
            (valueChange)="
              formGroup.controls[property.name].setValue($event); doChange()
            "
          >
            <mat-form-field
              [class.mat-form-field-invalid]="property.error"
              legacyAppearance
            >
              <input
                [attr.data-testid]="'action-input-' + property.name"
                matInput
                color="primary"
                [formControlName]="property.name"
                (change)="doChange()"
                (focus)="flexEditorService.isInputFocus$.next(true)"
                (blur)="flexEditorService.isInputFocus$.next(false)"
              />
              @if (property.name === 'uri') {
                <button
                  mat-icon-button
                  matSuffix
                  (click)="openUrlBuilderDialog(property.name)"
                  matTooltip="編輯 UTM 參數"
                  i18n-matTooltip="編輯 UTM 參數"
                >
                  <mat-icon> edit </mat-icon>
                </button>
              }
              <mat-hint>
                <span
                  [class.mat-error]="property.error"
                  [attr.data-testid]="'action-hint-' + property.name"
                >
                  {{
                    property.error || (property.hint === 'format' ? hint : '')
                  }}
                </span>
              </mat-hint>
            </mat-form-field>
          </programmable>
        }
        @if (
          !property.hint &&
          !property.options &&
          !property.treeOptions &&
          property.name === 'altUri'
        ) {
          <programmable
            [title]="property.name | cht"
            [formGroup]="$any(formGroup.controls.altUri)"
            [value]="formGroup.value.altUri.desktop"
            (valueChange)="
              $any(formGroup.controls.altUri).controls.desktop.setValue($event);
              doChange()
            "
          >
            <mat-form-field
              [class.mat-form-field-invalid]="property.error"
              legacyAppearance
            >
              <input
                [attr.data-testid]="'action-altUri-desktop-input'"
                matInput
                color="primary"
                formControlName="desktop"
                (change)="doChange()"
                (focus)="flexEditorService.isInputFocus$.next(true)"
                (blur)="flexEditorService.isInputFocus$.next(false)"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="openUrlBuilderDialog(property.name)"
                matTooltip="編輯 UTM 參數"
                i18n-matTooltip="編輯 UTM 參數"
              >
                <mat-icon> edit </mat-icon>
              </button>
              <mat-hint>
                <span
                  [class.mat-error]="property.error"
                  [attr.data-testid]="'action-altUri-desktop-hint'"
                >
                  {{
                    property.error || (property.hint === 'format' ? hint : '')
                  }}
                </span>
              </mat-hint>
            </mat-form-field>
          </programmable>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
